import React from 'react';
import PropTypes from 'prop-types';
import { MultiResolutionBackgroundDiv } from '@domain-group/fe-co-multi-resolution-image';
import * as styles from './carousel-item.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PhotoCarouselItem = _ref => {
  var item = _ref.item,
    className = _ref.className;
  return ___EmotionJSX("div", {
    className: className,
    key: item.src
  }, ___EmotionJSX(MultiResolutionBackgroundDiv, {
    css: styles.image,
    src: item.srcHighDef,
    srcLowResolution: item.src
  }));
};
PhotoCarouselItem.propTypes = {
  item: PropTypes.shape({
    src: PropTypes.string,
    srcHighDef: PropTypes.string
  }).isRequired,
  className: PropTypes.string
};
PhotoCarouselItem.defaultProps = {
  className: ''
};
export default PhotoCarouselItem;